(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Wholesale-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const shopifyForms = document.querySelectorAll('form.wholesale-form');

  shopifyForms.forEach(function (form) {
    let isSubmitting = false;

    form.addEventListener('submit', function (e) {
      if (isSubmitting) return;
      isSubmitting = true;

      e.preventDefault();

      const formData = new FormData(form);
      const formObject = {};

      formData.forEach((value, key) => {
        if (formObject[key]) {
          formObject[key] = [].concat(formObject[key], value);
        } else {
          formObject[key] = value;
        }
      });

      formObject.timestamp = new Date().toISOString();
      formObject.form_name =
        form.getAttribute('data-form-name') || 'contact_form';
      formObject.page_url = window.location.href;
      formObject.user_agent = navigator.userAgent;

      // Fire and forget
      fetch(
        'https://capturex.lantern-digital.com/api/webhook/40074b0f2499d4f208f18004e1c40c79d2d9194d8513f989475b6494b6d062e8',
        {
          method: 'POST',
          mode: 'no-cors',
          body: JSON.stringify(formObject),
        }
      ).catch(() => {
        // intentionally silent
      });

      // Let Shopify handle the actual submission
      form.submit();
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
